import AltInstance from '../Globals/Scripts/AltInstance';
import ActionHelper from './ActionHelper';

/*
 * Call these when starting a long-running task that should disable the UI -
 * for example an XHR or fetch.
 */
class ActionInProgressActions {
    constructor() {
        this.generateActions(
            'actionStarted',
            'actionCompleted'
        );
    }
}

export default AltInstance.createActions(ActionInProgressActions);
